import EventEmitter from "events";
import { Logger } from "../utils/logger";
import { dataAttributePrefix } from "../index";
import { FormSubmissionMonitor } from "./form-submission-monitor";
import { DataTrackingClient } from "../core";
import { XHRInterceptor } from "./xhr-interceptor";
import { VimeoMonitor } from "./vimeo-monitor";
import { YoutubeMonitor } from "./youtube-monitor";
import { FetchInterceptor } from "./fetch-interceptor";
export class DOMElementEventMonitor {
    constructor() {
        this._dataAttributePrefix = dataAttributePrefix;
        this._trackingElements = [];
        this._emitter = new EventEmitter();
        if (DOMElementEventMonitor._instance) {
            throw new Error("Singleton class [DOMElementEventMonitor] can't be instantiated more than once. Call getInstance() instead");
        }
    }
    static getInstance() {
        if (!DOMElementEventMonitor._instance) {
            DOMElementEventMonitor._instance = new DOMElementEventMonitor();
        }
        return DOMElementEventMonitor._instance;
    }
    onEvent(callBack) {
        this._emitter.on("event", (ev, element, elementEventData) => {
            callBack.call(this, ev, element, elementEventData);
        });
    }
    init(trackingItems) {
        Logger.info("Attatching DOM Element Events");
        //We'll be overriding HTMLFormElement.submit() method, as this method does not trigger the submit() event.
        //So in our overriden function, we'll able to catch if a form submission is tirggered by calling submit()
        FormSubmissionMonitor.getInstance().overideSubmitMethod();
        this._trackingElements = trackingItems;
        for (let i = 0; i < trackingItems.length; i++) {
            Logger.verbose("Attaching event listeners to tracking item => ", trackingItems[i]);
            if (trackingItems[i].whatToTrack == "form" && trackingItems[i].formConfig && trackingItems[i].formConfig.submitType == "ajax") {
                /* Forms that are submitted via AJAX needs special treatment */
                XHRInterceptor.getInstance().addItem(trackingItems[i]);
                FetchInterceptor.getInstance().addItem(trackingItems[i]);
            }
            else if (trackingItems[i].whatToTrack == "ajax" && trackingItems[i].ajaxConfig) {
                XHRInterceptor.getInstance().addItem(trackingItems[i]);
                FetchInterceptor.getInstance().addItem(trackingItems[i]);
            }
            else {
                if (trackingItems[i].elementSelector != '') {
                    this._attachDomEvents(trackingItems[i]);
                }
                else {
                    Logger.debug("Skipped trackingItems - elementSelector is empty => ", trackingItems[i]);
                }
            }
        }
        /*
            Attach a mutation observer on the body tag, so that we can monitor dynamically populated
            DOM elements and attach our own even listeners
        */
        const mutationObserver = new MutationObserver((mutationList, observer) => {
            for (const mutation of mutationList) {
                if (mutation.type == "childList") {
                    Logger.debug("MutationObserver's callback invoked");
                    for (let i = 0; i < mutation.addedNodes.length; i++) {
                        /*
                        *   Loop through each tracking elements and see if an elements queryselector
                        *   matches with any node in the mutation (newly added elements).
                        *   If a match is found, attach dom event monitoring to it.
                        */
                        const node = mutation.addedNodes[i];
                        if (node.nodeType == Node.ELEMENT_NODE) {
                            Logger.debug("Checcking trackingItems to find if any configured trackingItem exists in the new nodes");
                            for (let i = 0; i < this._trackingElements.length; i++) {
                                //if (trackingItems[i].whatToTrack != "ajax" && (trackingItems[i].whatToTrack == "form" && trackingItems[i].formConfig.submitType != "ajax")) {
                                if (trackingItems[i].elementSelector != '') {
                                    if (node.matches(trackingItems[i].elementSelector)) {
                                        Logger.debug("Found matching element => ", trackingItems[i]);
                                        this._bindElement(trackingItems[i], node);
                                        break;
                                    }
                                    else {
                                        Logger.debug("Matching element not found. Checking childrens");
                                        this._attachDomEvents(trackingItems[i], node);
                                    }
                                }
                            }
                        }
                    }
                }
            }
        });
        const bodyNode = document.querySelector('body');
        if (bodyNode) {
            mutationObserver.observe(bodyNode, { childList: true, attributes: false, subtree: true });
        }
    }
    _attachDomEvents(item, rootElement = null) {
        Logger.debug("Trying to attatching element => " + item.elementSelector);
        Logger.verbose(item);
        let elements;
        if (rootElement) {
            elements = rootElement.querySelectorAll(item.elementSelector);
        }
        else {
            elements = document.querySelectorAll(item.elementSelector);
        }
        if (elements.length == 0) {
            Logger.debug("No element found with matching selector =>" + item.elementSelector);
        }
        for (let i = 0; i < elements.length; i++) {
            this._bindElement(item, elements[i]);
        }
    }
    _bindElement(trackingItem, htmlElement) {
        // Attach the elementId as data attribute to all matched elemets, so that we can access
        // The tracking config from the trackingElemets array using the elementId when an event 
        // will be generated on this element
        htmlElement.setAttribute(this._dataAttributePrefix + "element-id", trackingItem.elementId.toString());
        if (trackingItem.whatToTrack == 'vimeo-video') {
            VimeoMonitor.getInstance().addItem(trackingItem, htmlElement);
        }
        else if (trackingItem.whatToTrack == 'youtube-video') {
            // Youtube Tracking .......
            Logger.verbose("Youtube - YoutubeMonitor addItem");
            YoutubeMonitor.getInstance().addItem(trackingItem, htmlElement);
        }
        else {
            ((objDOMElementEventMonitor) => {
                htmlElement.addEventListener(trackingItem.eventName, function (ev) {
                    Logger.verbose(ev.type + " triggered on => ", this);
                    objDOMElementEventMonitor._handleHTMLElementEvent(this, ev);
                });
            })(this);
        }
    }
    _handleHTMLElementEvent(element, ev) {
        // Retreive the elementId (db record, not the dom ID) from the data attribute.
        // We already assigned it in processDomElementTracking()
        let elementId = element.getAttribute(this._dataAttributePrefix + "element-id");
        if (!elementId) {
            Logger.error(this._dataAttributePrefix + "element-id data attribute not found on element");
            return;
        }
        // Get the item from trackElements array based on the elementId
        let trackingItem = DataTrackingClient.getInstance().getTrackingElementById(parseInt(elementId));
        if (trackingItem == null) {
            Logger.error("Element with id (" + elementId.toString() + ") not found in elements array");
            Logger.verbose(this._trackingElements);
            return;
        }
        //let parentSelector: string = trackingItem.parentSelector || "";
        //let elementSelector: string = trackingItem.elementSelector || "";
        if (trackingItem.elementSelector == "") {
            Logger.error("elementSelector cannot be empty");
            return;
        }
        // If the elements are tracked based on a parent container (dynamically populated elements)
        // Then we'll find all the children of the parent (based on the query selector)
        // and shall check if the event was generated from any of our designated childrens
        /*
        if (parentSelector != "") {
            Logger.verbose("Event has been fired on a parent container. Finding child element with matching selector.");
            let childElements: NodeListOf<HTMLElement> = element.querySelectorAll(elementSelector);

            Logger.verbose("Child elements");
            Logger.verbose(childElements);

            let childFound = false;
            childElements.forEach((elm, index) => {
                if (elm.getAttribute(this._dataAttributePrefix + "element-id") === elementId) {
                    childFound = true;
                    element = elm;
                }
            });

            if (!childFound) {
                // If the event was generated from any other child element that is not designated for tracking
                // then we won't process further.
                Logger.error("Child element not found");
                return;
            }
        }
        */
        if (ev.type.toLowerCase() == 'submit' && element instanceof HTMLFormElement) {
            Logger.debug("Form submission detected. Attaching monitor.");
            FormSubmissionMonitor.getInstance().monitor(element, trackingItem);
        }
        else {
            let elementEventData = DataTrackingClient.getInstance().prepareElementEventData(trackingItem, element);
            this._emitter.emit("event", ev, element, elementEventData);
        }
    }
}
DOMElementEventMonitor._instance = null;
